export const tradingContest = {
  cyjyds: "Participe da competição comercial",
  jsjxmh: "Desbloqueie a caixa cega surpresa e ganhe super prêmios",
  hdsj: "Tempo de atividade",
  mrjxsj: "Realizado das 00h00 às 23h59 UTC+8 todos os dias.",
  ckxxgz: "Regras detalhadas",
  wdjj: "Meu bônus",
  jlkj: "Contagem regressiva",
  cjjc: "Super prêmio",
  jjmrzj: "O acúmulo diário de bônus aumenta",
  kqxjd: "Abra uma nova etapa e aumente o número de recompensas",
  dyjd: "Estágio 1",
  dejd: "Estágio 2",
  dsjd: "Estágio 3",
  dsijd: "Estágio 4",
  jrmhjj: "Bônus da caixa cega de hoje",
  syjj: "Bônus restante",
  yblqje: "Valor recebido",
  tjmh: "Caixa cega especial",
  yjmh: "Caixa de 1 níveis",
  ejmh: "Caixa de 2 níveis",
  sjmh: "Caixa de 3 níveis",
  jj: "Bônus: ",
  gs: "peça",
  djdkrymh: "Clique para abrir qualquer caixa surpresa surpresa",
  kydk: "Você pode abri-lo hoje",
  jxmh: "Caixa cega surpresa",
  dkmhxyxx: "São necessárias {amount} estrelas para abrir uma caixa cega. ",
  xzyyxx: "Agora você tem {amount} estrelas",
  xxqlsj: "Tempo de eliminação das estrelas: {date} （Por favor, recolha a caixa cega antes que as estrelas sejam eliminadas）",
  wdxx: "minha estrela",
  xxhq: "Aquisição de estrelas",
  hqxxtj: "Como conseguir estrelas",
  yxhysxf: "Contrato Perpétuo: Ganhe 1 estrela para cada {amount}U de taxas de manuseio",
  qqhysxf: "Contratos de opções: Ganhe 1 estrela para cada {amount}U de volume de negociação",
  youxihysxf: "GameFi: Ganhe 1 estrela para cada {amount}U de volume de transações",
  gxhd: "Parabéns",
  jlydrzh: "A recompensa foi creditada em sua '{account}'",
  qzjzhck: "Vá para a conta Gamefi para visualizar",
  bwcjjc: "Super Prêmio",
  qmxjyds: "Competição de negociação All-Star",
  gbgbyb: "Você se atreve a tentar?",
  bwcjjcdnn: "Super premiação de bicicleta, {amount}% do prêmio da caixa cega para você todos os dias!",
  cjjcqmxjys: "{amount}% do prêmio da competição All-Star Trading Biking Super Prize Pool é adicionado à caixa cega todos os dias. ",
  syyxbd: "Basta abri-la e ganhar com uma pequena quantia!",
  zgtk: "Quer chegar ao topo? Venha e lute!",
  zhyz: "{amount}% do prêmio diário é acumulado até a batalha final. ",
  dfdj: "Quem pode ganhar o prémio máximo do Biking?",
  gsjj: "Os mestres da Competição de Negociação All-Star do Biking",
  qmxpk: "Super Prize Pool se reúnem para ver os resultados reais do All-Star PK!",
  jymh: "Negocie, faça blind box, classifique-se e divirta-se na Biking Arena!",
  zzbzy: "Contratos perpétuos, opções, GameFi, negociação à vista, a jogabilidade circundante é atualizada camada por camada e nunca é a mesma todas as semanas!",
  jlfh: "Biking Super Prize Pool All-Star Trading Competition, recompensas generosas estão esperando por você para ganhar fama e fortuna e se tornar o herói!",
  mh: "caixa cega",
  cb: "Corra para o topo",
  jy: "Transação",
  syxxs: "Número de estrelas restantes",
  xxbhs: "O número de estrelas muda",
  sjlx: "tipo de evento",
  jycp: "Comercialização de produtos",
  jye: "Volume de transações",
  myxgjl: "Você ainda não recebeu nenhuma recompensa relevante",
  jyhd: "Transação obtida",
  ql: "Claro",
  kqmh: "Abra a caixa cega",
  yx: "Jogos GameFi",
  bchdyjs: "Este evento terminou",
  gffjj: "Um total de prêmios serão distribuídos nesta competição",
  kqmhsl: "Ativar quantidade de caixa cega",
  cjjcjj: "Bônus de super jackpot",
  cjjchjmd: "Lista de vencedores do super prêmio",
  jjdyyh: "O bônus foi creditado na conta de fundos do usuário",
  hdjj: "ganhe bônus",
  wff: "Não emitido",
  mhhjjl: "Caixa Surpresa",
  cjdjhjjl: "Super Prêmio",
  jjse: "Valor do bônus",
  xhxxs: "Número de estrelas consumidas",
  bwqmxgz: "Regras da competição de negociação All-Star de bicicleta",
  hdnr: "Conteúdo da atividade",
  hdnrgz: "A competição de negociação All-Star do Biking Super Prize Pool cobre quatro áreas principais: contratos perpétuos, contratos de opções, jogos GameFi e negociação à vista. O evento é dividido em quatro semanas, e novos produtos comerciais são desbloqueados gradualmente a cada semana, permitindo que você obtenha “estrelas” em desafios comerciais multidimensionais e ganhe recompensas generosas. {total}% do prêmio diário é usado para sorteios de blind box e recompensas surpresa estão disponíveis imediatamente! Os {amount}% restantes serão acumulados até o final da competição, e a maior recompensa será dividida de acordo com a classificação da transação!",
  hdjd: "Estágio de atividade",
  jbjs: "Desbloqueie gradualmente quatro ciclos de atualizações de competição",
  dyzq: "Primeiro ciclo",
  kqyxhy: "Habilite a negociação por contrato perpétuo. Quanto maior o volume de negociação, mais pontos estelares e maiores serão as recompensas do prêmio!",
  dezq: "Segundo ciclo",
  jmqqjy: "Aumente a negociação de contratos de opções e ganhe um jackpot bidirecional para lucros e perdas, permitindo que você atualize seu número de estrelas novamente.",
  dszq: "Terceiro ciclo",
  cjgejc: "Junte-se ao jogo GameFi, ganhe estrelas através de diversas experiências de negociação e ganhe grandes prêmios.",
  dsizq: "Quarto ciclo",
  gfzzdj: "A premiação da blind box continuará aberta nas primeiras três semanas, e a lista de negociação spot será configurada separadamente para compartilhar o prêmio final!",
  jzszjs: "Cálculo do prêmio do pool de prêmios",
  jxmhgz1: "Todos os dias, {amount}% das mercadorias são distribuídas em caixas cegas, 100 caixas cegas são abertas imediatamente e quatro tipos de mercadorias são entregues ao mesmo tempo. os lucros aumentaram! Caixas cegas de grau especial, caixas cegas de primeiro grau, etc. são atualizadas todos os dias, e a taxa superalta de ordem média, etc.",
  mhfpmx: "O número de caixas cegas é de {total} por dia e o número de caixas cegas é de {amount}%. Detalhes de distribuição da caixa cega:",
  tjmhzb: "{total} blind box especial, representando {amount}% do prêmio total",
  yjmhzb: "Existem {total} blind boxes de primeiro nível, representando {amount}% do prêmio total",
  ejmhzb: "Existem {total} blind boxes secundárias, representando {amount}% do prêmio total",
  sjmhzb: "Existem {total} blind boxes de terceiro nível, representando {amount}% do prêmio total",
  kmhxxyq: "O número de estrelas necessárias para abrir a blind box: valor do prêmio diário da blind box/{text}",
  tips: "Nota: 0 itens são atualizados todos os dias quando o livro é aberto, e é calculada a quantidade de dinheiro que é adicionada à quantidade de dinheiro que foi aberta no dia anterior.",
  mrjyyk: "O prêmio total é baseado nos lucros e perdas comerciais diárias nos três principais setores de contratos perpétuos, contratos de opções e GameFi.",
  mgyld: "{amount}% de cada ordem de lucro = valor do lucro * {amount}%",
  mrjcljdjs: "{amount}% da premiação diária será acumulada até o final do evento e será dividida entre os três primeiros colocados no ranking dos quatro principais produtos comerciais. As proporções do prêmio contínuo são: 40% para contratos perpétuos, 30% para opções, 20% para GameFi e 10% para produtos spot.",
  yhhyyld: "Por exemplo: se o lucro do pedido do contrato do usuário for 1.000U, então 1.000*{amount}%={total}U entrará no prêmio do dia",
  mgksd: "{amount}% de cada pedido de perda = valor real da perda (perda - liquidação) * {amount}%",
  yhhyks: "Por exemplo: se o pedido de contrato do usuário realmente perder 1.000U, então 1.000*{amount}%={total}U entrará na premiação do dia.",
  qqhyyld: "{amount}% de cada ordem de lucro = valor da aposta * probabilidades * {amount}%",
  qqyhddtz: "Por exemplo: se um usuário apostar 100U em uma ordem de opção e obtiver lucro em um período de 10 segundos, então 100*65%*{amount}%={total}U entrará no prêmio do dia.",
  qqhyksd: "{amount}% de cada pedido de perda = valor da perda * {amount}%",
  yhksjrjc: "Por exemplo: se a opção de perda de pedido do usuário for 100U, então 100*{amount}%={total}U entrará no prêmio do dia.",
  yxyld: "{amount}% de cada ordem de lucro = valor da aposta * probabilidades * {amount}%",
  yxddtz: "Por exemplo: A ordem gamefi do usuário aposta 100U, assumindo que as probabilidades são 2 vezes. Se você tiver lucro, 100*200%*{amount}%={total}U entrará no prêmio do dia.",
  yxmgksd: "{amount}% de cada pedido de perda = valor da perda * {amount}%",
  yhqqksd: "Por exemplo: se a opção de perda de pedido do usuário for 100U, então 100*{amount}%={total}U entrará no prêmio do dia.",
  daiding: "pendente",
  yytz: "Ajuste de atividade",
  kaiqi: "Aberto",
  xhjyjrpm: "A negociação à vista entra no ranking",
  drjy: "Negocie no mesmo dia e receba no dia seguinte",

}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/pt_BR.js